import { LAYOUT_PART } from "app/shared/constants";

export class LoadingModel {
    visible!: boolean;
    shading!: boolean;
    message = '';
    // skipcq: JS-0323
    position: any = { of: LAYOUT_PART.body };
    timeout = 0;

    constructor(init?: Partial<LoadingModel>) {
        if (init) {
            Object.assign(this, init);
        }
    }
}